
import { changeNumberValue } from "../../../../store/model";
import { AppDispatch } from "../../../../store/store";

export interface ValueSetGet<T> {
  setValue: (input: T) => void;
  currentValue: T;
}

export function hasKey<O extends GeometricShape>(obj: O, key: PropertyKey): key is keyof O {
  return key in obj
}

function getNumberValue(shape: GeometricShape, name: string, defaultValue?: number) {
  if (hasKey(shape, name)) return shape[name] ?? 0;
  else return 0;
}
function setNumberValue(shape: GeometricShape, dispatch: AppDispatch, key: string) {
  return function (number: number) {
    const payload = {
      id: shape.id,
      propertyValue: number,
      propertyName: key,
    };
    dispatch(changeNumberValue(payload));
  };
}
// function setNumberValue(shape: GeometricShape, name: string) {
//   return function (input: number, dispatch: AppDispatch) {
//     const actionPayload = {
//       id: shape.id,
//       propertyValue: input,
//       propertyName: name,
//     };
//     dispatch(changeNumberValue(actionPayload));
//   };
// }

function getListNameAndId(list: Layer[]) {
  return list.map(i => { return { label: i.name, value: i.id } })
}

function setLayer(shapeId: number, inputLayerId: number, dispatch: AppDispatch) {
  const payload = {
    id: shapeId, propertyValue: inputLayerId, propertyName: "layerId"
  }
  dispatch(changeNumberValue(payload))
}

function getColorValue(shape: GeometricShape, name: string) {
  return function (): ColorValue {
    // console.log(shape.stroke, "instroke");
    if (hasKey(shape, name)) return shape[name] ?? "#000000";
    else return "#000000";
  };
}

function setColorValue(shape: GeometricShape, name: string) {
  // return function (input: ColorValue) {
  //   const actionPayload = {
  //     id: shape.id,
  //     propertyValue: input,
  //     propertyName: name,
  //   };
    //useAppDispatch(changeColorValue(actionPayload));
  // };
}
export {
  getNumberValue, setNumberValue,
  getColorValue, setColorValue, getListNameAndId, setLayer
};
